import React from "react";
import { CoverImage } from "@/components/CoverImage";
import { Carousel } from "./Carousel";
import { ShopifyMedia } from "@/store";
import { CoverVideo } from "../CoverVideo";
import { PdpBadge } from "@/modules/PdpFlow";
import { CarouselProps, Dots } from "@/components/carousel/Carousel.types";

export type MediaCarouselProps = Omit<
  CarouselProps,
  "items" | "slidePosition"
> & {
  media: ShopifyMedia[];
  imagePosition?: "center" | "top" | "bottom" | "cover";
  title: string;
  dots?: Dots | "none";
};

export const MediaCarousel = ({
  media = [],
  title = "product",
  arrows = { variant: "white-icon", gutter: "none" },
  dots = { placement: "bottom", gutter: "none" },
  slideGap = false,
  imagePosition = "cover",
}: MediaCarouselProps) => {
  const isCoverImage = imagePosition === "cover";
  const slidePosition = isCoverImage ? "stretch" : imagePosition;
  let items = media.map((item, i) => (
    <div key={item.url} className={isCoverImage ? "flex h-full w-full" : ""}>
      {item.mediaType === "video" ? (
        <div className="pdp-video-slide h-full pb-10">
          <CoverVideo
            url={item.url}
            sources={item.sources}
            alt={item.alt || `${title} highlight video`}
            autoPlay={false}
          />
        </div>
      ) : (
        <>
          <PdpBadge index={i} />
          <CoverImage
            src={item.url}
            alt={item.alt ?? ""}
            width={item.width ?? undefined}
            height={item.height ?? undefined}
            loading={i === 0 ? "eager" : "lazy"}
          />
        </>
      )}
    </div>
  ));

  return (
    <Carousel
      data-id="image-carousel"
      items={items}
      dots={dots}
      arrows={arrows}
      slideGap={slideGap}
      slidePosition={slidePosition}
    />
  );
};
